import { API_URLS } from "../Constants/api.constants";
import api from "./api";
import { errorHandling } from "./error.handling";

const basePath = API_URLS.MAINTENANCES;

// Extrai a mensagem de negócio de dentro do texto técnico que a procedure devolve.
// Formato típico:
// "Procedure: [ofv3_Maintenance].[SchedulingEdit]\r\nErro: <mensagem útil>\r\nSeveridade: 16\r\nEstado: 1\r\n<mensagem útil repetida>"
function extractProcedureMessage(message) {
    if (!message || typeof message !== "string") return null;

    const lines = message.split(/\r?\n/).map(l => l.trim()).filter(Boolean);

    // Prioriza a linha que começa com "Erro:" e remove o prefixo
    const erroLine = lines.find(l => /^erro:/i.test(l));
    if (erroLine) {
        return erroLine.replace(/^erro:\s*/i, "");
    }

    // Fallback: última linha, desde que não seja uma linha técnica conhecida
    const lastLine = lines[lines.length - 1];
    if (lastLine && !/^(procedure|severidade|estado):/i.test(lastLine)) {
        return lastLine;
    }

    return null;
}

function extractErrorMessage(data) {
    if (!data) return null;

    if (Array.isArray(data.validations) && data.validations.length > 0) {
        const validationMessages = data.validations
            .map((v) => v.message)
            .filter(Boolean);
        if (validationMessages.length > 0) {
            return validationMessages.join(" ");
        }
    }

    // 1) Tenta extrair a mensagem de negócio específica da procedure (mais útil pro usuário)
    const procedureMessage = extractProcedureMessage(data.message);
    if (procedureMessage) return procedureMessage;

    // 2) Cai para os campos genéricos de erro da API
    return data.friendlyMessage || data.error || data.detail || data.title || null;
}

async function fetchItemsMaintenace() {
    try {
        let response = await api.get(`${basePath}/items`);

        let treated = errorHandling.handleResponse(
            response,
            "maintenancesService.fetchItemsMaintenace"
        );
        if (treated) {
            // Normaliza: sempre retorna array
            return Array.isArray(treated) ? treated : [treated];
        }
        return null;
    } catch (error) {
        errorHandling.cathError(error, "maintenancesService.fetchItemsMaintenace");
        return null;
    }
}

async function createNewItem(item) {
    const payload = {
        maintenanceItemId: item.maintenanceItemId,
        maintenanceItemName: item.maintenanceItemName,
        active: item.active
    }
    try {
        let response = await api.post(`${basePath}/items`, JSON.stringify(payload));

        // let treated = errorHandling.handleResponse(
        //     response,
        //     "maintenancesService.createNewItem"
        // );
        if (response.status === 201) {
            // Normaliza: sempre retorna array
            return response.status === 201 ? true : false;
        }
        return null;
    } catch (error) {
        errorHandling.cathError(error, "maintenancesService.createNewItem");
        throw error;
    }
}

async function createNewScheduling(scheduling) {
    const payload = {
        MaintenanceScheduleId: scheduling.maintenanceScheduleId ?? 0,
        VehicleId: scheduling.vehicleId,
        MaintenanceItemId: scheduling.maintenanceItemId,
        MaintenanceBase: scheduling.maintenanceBase === "" ? "DI" : scheduling.maintenanceBase,
        Mileage: scheduling.mileage ?? 0,
        Days: scheduling.days ?? 0,
        Hours: scheduling.hours ?? 0,
        Active: scheduling.active ?? "S",
        Cost: scheduling.cost ?? 0,
        MaintenanceStatus: scheduling.maintenanceStatus ?? 1,
        StartDate: scheduling.startDate ?? null,
        ExecutionDate: scheduling.executionDate ?? null
    };

    try {
        let response = await api.post(`${basePath}/schedules`, JSON.stringify(payload));

        if (response.status === 201) {
            return true;
        }
        // Resposta sem sucesso, mas sem lançar exceção (ex: 200 com erro no body)
        return {
            error: true,
            message: extractErrorMessage(response.data)
        };
    } catch (error) {
        errorHandling.cathError(error, "maintenancesService.createNewScheduling");
        // Captura a mensagem que a procedure devolveu (ex: 400/409 com body de erro)
        return {
            error: true,
            message: extractErrorMessage(error?.response?.data)
        };
    }
}

async function fetchItemsScheduling(vehicleId, isOpen) {
    try {
        const isOpenParam = isOpen ? 'S' : 'N';
        let response = await api.get(`${basePath}/schedules?vehicleId=${vehicleId}&isOpen=${isOpenParam}`);

        let treated = errorHandling.handleResponse(
            response,
            "maintenancesService.fetchItemsScheduling"
        );
        if (treated) {
            // Normaliza: sempre retorna array
            return Array.isArray(treated) ? treated : [treated];
        }
        return null;
    } catch (error) {
        errorHandling.cathError(error, "maintenancesService.fetchItemsScheduling");
        return null;
    }
}


export const maintenancesService = {
    fetchItemsMaintenace,
    createNewItem,
    createNewScheduling,
    fetchItemsScheduling
};
